export default __webpack_public_path__ + "static/media/DarkLogo.a0ac1043.svg";